import { MinimalProfile } from 'src/app/core/models/user/profile';
import { OrganizationSearchConfig } from 'src/app/core/utils/organization-search-util';

export class EditableContact {
  public readonly organizationSearchConfig = OrganizationSearchConfig;

  public employeeFullNameFilter: (employee: MinimalProfile, term: string) => boolean = (
    employee,
    term,
  ) => employee?.fullName.toLowerCase().includes(term.toLowerCase());

  public employeeFormatter: (employee: MinimalProfile | null | undefined) => string =
    (employee) => employee?.fullName ?? '';

  public employeeCompareFn: (
    employee: MinimalProfile,
    value: MinimalProfile,
  ) => boolean = (employee, value) => employee.fullName === value.fullName; 
}
